/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './FilePickerButton.css';

class FilePickerButton extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    const fileData = this.ref.files[0];
    this.props.onChange(fileData);
  }

  render() {
    const inputId = `input-${this.props.name}`;
    return (
      <label className={classnames('cmp-filepickerbutton', this.props.className)} htmlFor={inputId}>
        <div className="content">
          {this.props.children}
        </div>
        <input
          name={this.props.name}
          id={inputId}
          type="file"
          accept={this.props.accept}
          ref={(r) => { this.ref = r; }}
          onChange={this.handleChange}
        />
      </label>
    );
  }
}

FilePickerButton.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  accept: PropTypes.string,
  className: PropTypes.string,
};

FilePickerButton.defaultProps = {
  accept: '*',
};

export default FilePickerButton;
